// extracted by mini-css-extract-plugin
export default {"root":"style_root__QgTvD","tricks":"style_tricks__X4JrF","rounds":"style_rounds__Qrt--"};